import styled from '@emotion/styled'
import {
  DEFAULT_DRAWER_WIDTH,
  TAB_WIDTH,
  DRAWER_TRANSITION_MS,
} from 'utils/drawerConstants'
import { themeColor, stylesIf } from 'utils/styles'
import Header from 'components/patterns/Typography/Header'

const blockForwardingProps = new Set([
  'drawerWidth',
  'visibleWidth',
  'fullscreen',
  'contrastBkg',
  'showTab',
])

const isValid = (prop) => !blockForwardingProps.has(prop)

export const StyledDrawer = styled('div', {
  shouldForwardProp: isValid,
})((props) => {
  const {
    placement,
    fullscreen,
    drawerWidth,
    visibleWidth,
    contrastBkg,
    showTab,
  } = props
  const isRight = placement === 'right'
  const isLeft = placement === 'left'
  const { drawerBorderColor } = props.theme

  const computeWidth = fullscreen ? '100%' : `${drawerWidth}px`

  const openTranslation = fullscreen ? 0 : `${drawerWidth - visibleWidth}px`

  return `
    display: flex;
    flex-direction: column;
    ${stylesIf(!fullscreen, `padding: 20px;`)}
    overflow: visible;
    width: ${computeWidth};
    position: fixed;
    height: 100%;
    top: 0;
    ${stylesIf(isRight, 'right: 0;')}
    ${stylesIf(isLeft, 'left: 0;')} 
    transform: translateX(${computeWidth});
    background: ${themeColor(
      contrastBkg ? 'modalGrey' : 'whitePrimary',
      props
    )};
    z-index: 999;
    border-left: ${showTab ? 'none' : `2px solid ${drawerBorderColor}`};
    transition: all ${DRAWER_TRANSITION_MS}ms cubic-bezier(0.9,0,0.3,0.7);
    transition-property: transform;
    box-shadow: 1px 0px 5px -5px rgba(0,0,0,0.2), 1px 0px 0px 0px rgba(0,0,0,.12), 0px 0px 6px 1px rgba(0,0,0,0.14);

    &.wide-1025 {
      width: 1025px;
    }

    &.drawer-entering, &.drawer-entered {
      transform: translateX(${openTranslation});
    }

    &.drawer-entering.drawerExpanded-entering, &.drawer-entered.drawerExpanded-entered {
      transform: translateX(0);
    }
  `
})

export const Mask = styled.div((props) => {
  const { shadow } = props.theme.color

  return `
    background: ${shadow};
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
  `
})

export const Tab = styled.div((props) => {
  const { whitePrimary } = props.theme.color
  const { drawerBorderColor } = props.theme

  return `
    position: absolute;
    z-index: -1;
    left: -29px;
    padding: 9px;
    box-shadow: -4px 2px 1px -5px rgba(0, 0, 0, 0.2), -2px 11px 5px -7px rgba(0, 0, 0, .12), -3px 0px 5px 0px rgba(0, 0, 0, 0.14);
    border-radius: 22px 0 0 22px;
    border-color: ${drawerBorderColor};
    cursor: pointer;
    top: 48px;
    background: ${whitePrimary};
  `
})

export const shrinkWhenDrawerOpen = (
  editorOpen,
  visibleWidth = DEFAULT_DRAWER_WIDTH
) => `
    width: ${
      editorOpen ? `calc(100% - ${visibleWidth - TAB_WIDTH}px)` : '100%'
    };
    margin-bottom: 20px;
    transition: width 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);
       `

export const DrawerRow = styled.div`
  padding-left: 34px;
  padding-right: 34px;
`

export const DrawerHeader = styled(DrawerRow)`
  border-bottom: 1px solid ${themeColor('drawerBorderColor')};
  padding-top: 32px;
  padding-bottom: 12px;
`.withComponent(Header)

export const DrawerHeaderRow = styled(DrawerRow)`
  border-bottom: 4px solid ${themeColor('blueSecondary')};
  padding: 0;
`
